'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('bulletin-archive', {
      url: '/bulletin/archive',
      template: '<bulletin-archive></bulletin-archive>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/bulletin/archive/bulletin-archive.routes.js